import { render } from "./detail.vue?vue&type=template&id=72cc1d8c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=72cc1d8c&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cc1d8c"],['__file',"src/views/food/restaurant/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72cc1d8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72cc1d8c', __exports__)) {
    console.log('reload')
    api.reload('72cc1d8c', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=72cc1d8c&scoped=true", () => {
    console.log('re-render')
    api.rerender('72cc1d8c', render)
  })

}


export default __exports__